import { Outlet } from '@tanstack/react-router'
import { Layout } from 'antd'
import { Header } from '@/components/layout/Header'
import { ChatWidget } from '@/components/layout/ChatWidget'
import { ChangePasswordModal } from './ChangePasswordModal'
import { SessionExpiredRedirect } from '@/components/auth/SessionExpiredRedirect'

const { Content } = Layout

export function Shell() {
  return (
    <Layout className="min-h-screen bg-[#f5f2ee] flex flex-col h-screen overflow-hidden">
      <Header />
      <SessionExpiredRedirect />

      {/* Make only this area scroll */}
      <Content className="px-8 pb-4 flex-1 overflow-y-auto overflow-x-hidden">
        <Outlet />
      </Content>
      
      <ChangePasswordModal />
    </Layout>
  )
}
